import { FormStepType } from "../types";
import { countries } from "../options/countries";
import { states } from "../options/states";
import { methodCommunication } from "../options/methodCommunication";
import getYesNoOptions from "../options/yes_no_options";
import { phoneTypesOptions } from "../options/phoneTypes";
import { emergencyContactGroup } from "./fields/emergency-contact-fields";

export const contact_information = ({
  additionalPhoneNumbers = 1,
}: {
  additionalPhoneNumbers?: number;
}): FormStepType => {
  const additionalPhoneFields: any[] = [];
  const phoneNumberArraytoAdds = ["phoneNumber2"];

  if (additionalPhoneNumbers === 2) {
    phoneNumberArraytoAdds.push("phoneNumber3");
    additionalPhoneFields.push({
      name: "additional-phone-2",
      condition: {
        field: "removeAdditionalPhoneNumber2",
        value: false,
      },
      fields: [
        {
          component: "TextInput",
          name: "phoneNumber3",
          label: "Additional Phone Number (Optional)",
          type: "tel",
          mask: "9999999999",
          validation: {
            required: "Please enter the telephone number.",
          },
          cols: 4,
        },
        {
          component: "Radio",
          name: "phoneNumber3Opt",
          label: "Phone Type",
          class: "radio--inline radio--phoneType",
          type: "radio",
          validation: {
            required: "Please select one value.",
          },
          options: phoneTypesOptions,
          cols: 4,
        },
        {
          component: "Check",
          type: "checkbox",
          class: "input-one-third check--removeAdditionalPhoneNumber check--asLink",
          name: "removeAdditionalPhoneNumber2",
          label: "Remove",
          value: "0",
          validation: {},
          cols: 4,
        },
      ],
    });
  }

  return {
    id: 2,
    name: "contact-information",
    title: "2. Contact Information",
    groups: [
      {
        name: "contact-information-address",
        title: "Where should the passport be mailed?",
        fields: [
          {
            component: "TextInput",
            name: "address1",
            label: "Street Address (P.O. Box, R.F.D, and U.R.B. accepted)",
            type: "text",
            cols: 6,
            maxLength: 36,
            validation: {
              required: "Please enter the address.",
              maxLength: 36,
              minLength: {
                value: 2,
                message: "The Street Address / RFD# Or P.O. Box must have at least two characters.",
              },
            },
          },
          {
            component: "TextInput",
            name: "address2",
            label: "Apartment, Company, Suite... (Optional)",
            type: "text",
            cols: 6,
            maxLength: 36,
            validation: {
              maxLength: {
                value: 36,
                message:
                  "The apartment, company, suite... must have maximum thirty-six characters.",
              },
              minLength: {
                value: 2,
                message: "The apartment, company, suite... must have at least two characters.",
              },
            },
          },
          {
            component: "TextInput",
            name: "city",
            label: "City",
            type: "text",
            cols: 4,
            maxLength: 15,
            validation: {
              required: "Please enter the city.",
              maxLength: 15,
              minLength: {
                value: 2,
                message: "The city must have at least two characters.",
              },
            },
          },
          {
            component: "Select",
            name: "country",
            label: "Country",
            type: "select",
            defaultValue: "US",
            validation: {
              required: "Please enter the country.",
            },
            cols: 4,
            options: countries,
          },
          {
            component: "Select",
            name: "stateTerritory",
            label: "State/Territory",
            placeholder: "Select a State",
            type: "select",
            validation: {
              required: "Please enter the state.",
            },
            cols: 4,
            options: states,
            condition: {
              field: "country",
              value: "US",
            },
          },
          {
            component: "TextInput",
            name: "zipCode",
            label: "Zip Code",
            type: "text",
            cols: 4,
            maxLength: 6,
            validation: {
              required: "Please enter the ZIP code.",
              maxLength: 6,
              minLength: {
                value: 2,
                message: "The ZIP code must have at least two characters.",
              },
            },
          },
        ],
      },
      {
        name: "permanent-Address",
        fields: [
          {
            component: "Radio",
            name: "permanentAddress",
            label: "Is this your permanent address?",
            type: "radio",
            validation: {},
            options: getYesNoOptions({}),
            tooltip:
              "Please, confirm whether your permanent address is the same as your mailing address.",
            defaultValue: "yes",
          },
        ],
      },
      {
        name: "permanent-Address-data",
        title: "Please enter your Permanent Address below",
        condition: {
          field: "permanentAddress",
          value: "no",
        },
        fields: [
          {
            component: "TextInput",
            name: "permanentAddress1",
            label: "Street Address/RFD#, P.O. Box, or URB",
            type: "text",
            placeholder: "",
            cols: 6,
            maxLength: 31,
            validation: {
              required: "Please enter the address.",
              maxLength: 31,
              minLength: {
                value: 2,
                message: "The Street Address / RFD# Or P.O. Box must have at least two characters.",
              },
            },
          },
          {
            component: "TextInput",
            name: "permanentAddress2",
            label: "Apartment, Company, Suite... (Optional)",
            type: "text",
            placeholder: "",
            cols: 6,
            maxLength: 4,
            validation: {
              maxLength: {
                value: 4,
                message: "The apartment, company, suite... must have maximum four characters.",
              },
              minLength: {
                value: 2,
                message: "The apartment, company, suite... must have at least two characters.",
              },
            },
          },
          {
            component: "TextInput",
            name: "permanentCity",
            label: "City",
            type: "text",
            placeholder: "",
            cols: 4,
            maxLength: 26,
            validation: {
              required: "Please enter the city.",
              maxLength: 26,
              minLength: {
                value: 2,
                message: "The city must have at least two characters.",
              },
            },
          },
          {
            component: "Select",
            name: "permanentCountry",
            label: "Country",
            type: "select",
            defaultValue: "US",
            validation: {
              required: "Please enter the country.",
            },
            cols: 4,
            options: countries,
          },
          {
            component: "Select",
            name: "permanentStateTerritory",
            label: "State/Territory",
            placeholder: "Select a State",
            type: "select",
            validation: {
              required: "Please enter the state.",
            },
            cols: 4,
            options: states,
            condition: {
              field: "permanentCountry",
              value: "US",
            },
          },
          {
            component: "TextInput",
            name: "permanentZipCode",
            label: "Zip Code",
            type: "text",
            cols: 4,
            maxLength: 6,
            validation: {
              maxLength: 6,
              required: "Please enter the ZIP code.",
            },
          },
        ],
      },
      {
        name: "mail-communication-method",
        fields: [
          {
            component: "Radio",
            name: "methodCommunication",
            label: "Preferred Method of Communication",
            type: "radio",
            defaultValue: "mail",
            validation: {
              required: "Please enter your preferred method of communication.",
            },
            options: methodCommunication,
          },
        ],
      },
      {
        name: "mail-communication-data",
        fields: [
          {
            component: "TextInput",
            name: "emailAddress",
            label: "Email (You will receive your confirmation here)",
            reviewLabel: "Email",
            type: "email",
            placeholder: "example@gmail.com",
            maxLength: 33,
            cols: 6,
            tooltip:
              "Make sure you include your email correctly as all future communication regarding your form will be received by email.",
            disclaimerAlert:
              "<b>Important</b>: Avoid using temporary email addresses or accounts with untrusted domains to complete this process correctly.",
          },
          {
            component: "TextInput",
            name: "emailAddressValidation",
            label: "Confirm your email",
            type: "email",
            placeholder: "example@gmail.com",
            maxLength: 33,
            cols: 6,
            tooltip: "Please re-type your email here.",
          },
        ],
      },
      {
        name: "primary-phone",
        fields: [
          {
            component: "TextInput",
            name: "phoneNumber1",
            label: "Primary Phone Number",
            type: "tel",
            mask: "9999999999",
            validation: {
              required: "Please enter the telephone number.",
            },
            cols: 4,
          },
        ],
      },
      {
        name: "additional-phone",
        condition: {
          field: "removeAdditionalPhoneNumber",
          value: false,
        },
        fields: [
          {
            component: "TextInput",
            name: "phoneNumber2",
            label: "Additional Phone Number (Optional)",
            type: "tel",
            mask: "9999999999",
            validation: { required: "Please enter the telephone number." },
            cols: 4,
          },
          {
            component: "Radio",
            name: "phoneNumber2Opt",
            label: "Phone Type",
            class: "radio--inline radio--phoneType",
            type: "radio",
            validation: {
              required: "Please select one value.",
            },
            options: phoneTypesOptions,
            cols: 4,
          },
          {
            component: "Check",
            errorMessage: "",
            type: "checkbox",
            value: true,
            class: "input-one-third check--removeAdditionalPhoneNumber check--asLink ",
            name: "removeAdditionalPhoneNumber",
            label: "Remove",
            validation: {},
            cols: 4,
          },
        ],
      },
      ...additionalPhoneFields, // Add additional phone fields if any
      {
        name: "additional-phone-action",
        fields: [
          {
            component: "AddAdditionalPhoneNumber",
            type: "addAdditionalPhoneNumber",
            fieldsToAdd: phoneNumberArraytoAdds,
            class: "",
            name: "addAdditionalPhoneNumber",
            label: "Add an additional phone number",
            validation: {},
            cols: 8,
          },
        ],
      },
      emergencyContactGroup,
    ],
  };
};
